import { axios } from 'utils/axios';

const sbSendMessage = (data) => {
    return axios.post('/safetybuddy/chat', {...data});
};

const sbGetHistory = (chat_id) => {
    return axios.get(`/safetybuddy/chat/${chat_id}/`);
};

const sbGetChatList = () => {
    return axios.get('/safetybuddy/chats');
};

const sbCreateNewChat = () => {
    return axios.post('/safetybuddy/chats/new');
};

export {
    sbSendMessage,
    sbGetHistory,
    sbGetChatList,
    sbCreateNewChat,
};
